import { createAction } from 'redux-actions';

export const NAMES = {
  SET: 'CLIENT.VIDEO.SAVED_TIME.SET',
};

export const setSavedTime = createAction(NAMES.SET);
